export default "__VITE_ASSET__CkDXy8q9__"